import { FC, PropsWithChildren } from "react";
import { ContainerBlock } from "./ContainerStyles";

const Container: FC<PropsWithChildren> = ({ children }) => {
  return <ContainerBlock>{children}</ContainerBlock>;
};

export default Container;
